import { ILLGenericKeys} from './index';


export class ILLInactiveIngridient {
 inActiveIngredientName: ILLGenericKeys;
 confidentiality: string;
 classCode: ILLGenericKeys;
 numValue: string;
 numValueUnit: ILLGenericKeys;
 denomValue: string;
 denomValueUnit: ILLGenericKeys;
}
